import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { TooltipContentProps } from 'recharts';

const Tooltip: React.FC<TooltipContentProps<number, string>> = ({
  active,
  payload,
  label,
}) => {
  if (!active || !payload || payload.length === 0) return null;

  const total = payload.reduce((acc, p) => {
    return acc + p.value;
  }, 0);

  const { t } = useTranslation();

  return (
    <div className={s.tooltip}>
      <div className={s.date}>{label}</div>

      {payload.map((entry, index) => (
        <div className={s.row} key={index}>
          <span>{entry.name}</span>
          <span className={s.value}>{entry.value}</span>
        </div>
      ))}
      <div className={s.row}>
        <span className={s.value}>{t('labels.total')}</span>
        <span>{total}</span>
      </div>
    </div>
  );
};

export default Tooltip;
